function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentionRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 389.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.58,
    y: 401.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.71,
    y: 399.53,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.21,
    y: 395.31,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.39,
    y: 73.68,
    width: 192.88,
    height: 214.99,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.31,
    y: 73.68,
    width: 196.22,
    height: 214.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.39,
    y: 288.67,
    width: 192.88,
    height: 11.65,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.09,
    y: 288.67,
    width: 196.22,
    height: 11.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.71,
    y: 91.84,
    width: 197.44,
    height: 178.67,
    transform: "translate(343.6 18.74) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.35 279.89 131.87 82.45 156.19 82.45 104.67 279.89 80.35 279.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.16,196a.63.63,0,0,1-.63-.63V88.16a.63.63,0,0,1,1.25,0V195.33A.63.63,0,0,1,77.16,196Z",
    style: {
      fill: "#f1f1f1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.89 279.89 161.41 82.45 170.89 82.45 119.38 279.89 109.89 279.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.49,
    y: 180.61,
    width: 197.44,
    height: 1.11,
    transform: "translate(432.38 -70.03) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 91.93 69.73 91.93 68.92 85.86 261.81 85.86 262.61 91.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 96.38 69.73 96.38 68.92 90.31 261.81 90.31 262.61 96.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 101.71 69.73 101.71 68.92 95.64 261.81 95.64 262.61 101.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 107.64 69.73 107.64 68.92 101.57 261.81 101.57 262.61 107.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 114.75 69.73 114.75 68.92 108.68 261.81 108.68 262.61 114.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 122.75 69.73 122.75 68.92 116.68 261.81 116.68 262.61 122.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.67 275.24 99.23 275.24 99.23 277.37 97.86 277.37 96.74 288.67 80.15 288.67 79.03 277.37 77.67 277.37 77.67 275.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.08,255.45s0,0,0,0c-.28-.94-.53-1.89-.77-2.84-1.41,1.83-2.78,2.29-3.8,2.29h-.33c-2-.2-4-2.16-5.19-5.25a.41.41,0,0,1,0-.36.4.4,0,0,1,.28-.22,10.64,10.64,0,0,1,8.56,1.48c-.19-.9-.34-1.8-.47-2.7a5.41,5.41,0,0,1-1,.1c-3.3,0-5.73-2.95-5.84-3.09a.44.44,0,0,1,.18-.68,6,6,0,0,1,5-.2,4.49,4.49,0,0,1,2,2,10.86,10.86,0,0,1,8.59-7.34.42.42,0,0,1,.52.4c.17,3,.08,6.67-2.17,8.42a5.15,5.15,0,0,1-3.24,1,12,12,0,0,1-3.08-.48,50.84,50.84,0,0,0,1.38,6.41,17,17,0,0,1,8.87-6.23.44.44,0,0,1,.53.31c.68,2.58.33,4.68-1,6.06a6.77,6.77,0,0,1-5,1.73,15.61,15.61,0,0,1-2.91-.31c.55,1.77,1.17,3.5,1.83,5.15,1.35-1.19,5.31-4.22,9.62-2.95a.41.41,0,0,1,.27.23.43.43,0,0,1,0,.35c-1.17,2.86-2.5,4.44-4.18,5a4.48,4.48,0,0,1-1.38.21,8.08,8.08,0,0,1-3.61-1.05c.94,2.18,1.91,4.23,2.85,6.05,1-1.09,3.78-3.35,8.69-2.3a.43.43,0,0,1,.34.46,5.28,5.28,0,0,1-3.14,4.22,5.05,5.05,0,0,1-2,.41,6.2,6.2,0,0,1-2.78-.71c2.18,4,3.92,6.56,4,6.62a.44.44,0,0,1-.72.49,88.57,88.57,0,0,1-4.77-8.13.42.42,0,0,1-.07-.13c-.29-.55-.57-1.11-.86-1.69a5.6,5.6,0,0,1-4.49,2.5,5.07,5.07,0,0,1-.55,0,5.4,5.4,0,0,1-4.44-3.47.42.42,0,0,1,.2-.52,9.18,9.18,0,0,1,8.38-.33c-.62-1.33-1.25-2.74-1.85-4.21a.56.56,0,0,1-.07-.18c-.17-.42-.34-.84-.5-1.26-1.44,1.82-2.88,2.71-4.37,2.71h0c-1.82,0-3.65-1.34-5.61-4.09a.43.43,0,0,1,.09-.6c3.08-2.31,7.31-.73,9.23.19-.39-1.08-.76-2.19-1.1-3.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.67,267.08a7.35,7.35,0,0,1-2.12.33,5.75,5.75,0,0,1-5.64-7.18.41.41,0,0,1,.46-.31,10.57,10.57,0,0,1,8.15,5.3c1-2.18,1.91-4.49,2.73-6.89a7.66,7.66,0,0,1-3.43,1,4.33,4.33,0,0,1-1.4-.23c-2.38-.81-3.81-3.72-5-6.75a.45.45,0,0,1,0-.36.4.4,0,0,1,.27-.22c4.89-1.36,8.85,3.31,10.08,5a58.76,58.76,0,0,0,1.61-6.13,17.33,17.33,0,0,1-3.09.3,7.57,7.57,0,0,1-5.68-2c-1.46-1.55-1.81-3.87-1-6.71a.43.43,0,0,1,.53-.31,18.63,18.63,0,0,1,9.59,7l.18-1.11a.45.45,0,0,1,.12-.25,5.36,5.36,0,0,1,2.68-3.31c1.45-.69,3.28-.59,5.43.29a.44.44,0,0,1,.17.69c-.13.15-2.79,3.3-6.38,3.3a6.5,6.5,0,0,1-1.14-.12c-.16,1-.35,2.06-.58,3.08a11.69,11.69,0,0,1,9.48-1.53.44.44,0,0,1,.29.59c-1.4,3.38-3.55,5.5-5.78,5.69h-.3c-1.13,0-2.65-.52-4.2-2.6a72.54,72.54,0,0,1-2.22,7c2.1-1,6.82-2.71,10.19-.1a.44.44,0,0,1,.08.6c-2.17,3-4.19,4.41-6.16,4.41h0c-1.64,0-3.21-1-4.77-3.07-.9,2.24-1.86,4.37-2.82,6.34,2.09-1.3,4.4-1.1,7.12.62a.44.44,0,0,1,.2.35.45.45,0,0,1-.18.37A10.75,10.75,0,0,1,100.6,272a4.89,4.89,0,0,1-2.88-.88,100.94,100.94,0,0,1-6.2,10.44.49.49,0,0,1-.4.21.46.46,0,0,1-.27-.09.48.48,0,0,1-.12-.67A103.66,103.66,0,0,0,98.67,267.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.17,
    y: 150.6,
    width: 45.25,
    height: 49.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.72,153.77a.22.22,0,0,1-.13,0c-.12-.07-12.19-7.25-16-7.25s-15.36,7.18-15.47,7.25a.26.26,0,0,1-.35-.08.24.24,0,0,1,.08-.34c.48-.3,11.76-7.33,15.74-7.33s15.79,7,16.29,7.32a.26.26,0,0,1,.08.35A.24.24,0,0,1,422.72,153.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.58,
    y: 150.6,
    width: 46.74,
    height: 49.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.02,
    y: 155.99,
    width: 41.86,
    height: 38.91,
    transform: "translate(584.4 -233.5) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,180.5a8.76,8.76,0,0,0-1.86.21,6,6,0,0,0,.24-1.65,5.73,5.73,0,0,0-1.35-3.7,4.65,4.65,0,0,0,1.35.22,4.82,4.82,0,1,0-3.81-1.93,5.76,5.76,0,1,0-2.06,11.17,8.56,8.56,0,0,0-1.18,4.35A8.67,8.67,0,1,0,410,180.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.62,161.92a4.77,4.77,0,1,1-4.77-4.76A4.78,4.78,0,0,1,401.62,161.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.99,
    y: 103.46,
    width: 51.14,
    height: 56.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.82,105.76a.28.28,0,0,1-.13,0c-.12-.08-12.2-7.26-16-7.26s-15.35,7.18-15.46,7.25a.25.25,0,0,1-.35-.08.25.25,0,0,1,.08-.34c.48-.3,11.75-7.33,15.73-7.33s15.8,7,16.3,7.33a.24.24,0,0,1,.08.34A.24.24,0,0,1,359.82,105.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.84,
    y: 103.46,
    width: 52.82,
    height: 56.15,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.6,
    y: 109.55,
    width: 47.3,
    height: 43.97,
    transform: "translate(476.79 -213.72) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.2,
    y: 113.1,
    width: 3.95,
    height: 44.96,
    rx: 1.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.35,135.58h-2.79l-.28,0v-8.77a1.59,1.59,0,0,0-1.59-1.59h-2.78a1.59,1.59,0,0,0-1.59,1.59v29.63a1.59,1.59,0,0,0,1.59,1.59h2.78a1.56,1.56,0,0,0,.94-.31,1.51,1.51,0,0,0,.93.31h2.79a1.59,1.59,0,0,0,1.59-1.59V137.17A1.59,1.59,0,0,0,342.35,135.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.74,
    y: 123.65,
    width: 13.48,
    height: 34.4,
    rx: 1.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.1,
    cy: 115.02,
    r: 4.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.14,275.17c0,7.45,8.06,13.5,18,13.5s18-6.05,18-13.5Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-85"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-85",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.63,
    cy: 416.24,
    rx: 18.07,
    ry: 1.11,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.04,
    y: 245.03,
    width: 213.65,
    height: 144.96,
    rx: 27.84,
    transform: "translate(597.73 635.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "350.3 416.24 335.35 416.24 304.97 344.26 327.85 344.26 350.3 416.24",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.19,
    y: 310.17,
    width: 1,
    height: 7.34,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.19,
    y: 310.17,
    width: 1,
    height: 7.34,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.19,
    y: 278.88,
    width: 1,
    height: 26.28,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.19,
    y: 278.88,
    width: 1,
    height: 26.28,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.58,
    y: 240.53,
    width: 13.56,
    height: 1,
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.58,
    y: 240.53,
    width: 13.56,
    height: 1,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "391.44 344.26 350.27 416.24 319.89 344.26 391.44 344.26",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.45 344.26 350.28 416.24 319.9 344.26 391.45 344.26",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "freepik--rectangle--inject-85",
    x: 204.62,
    y: 245.03,
    width: 201.08,
    height: 144.96,
    rx: 27.84,
    transform: "translate(610.31 635.02) rotate(180)",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "freepik--rectangle--inject-85",
    x: 204.62,
    y: 245.03,
    width: 201.08,
    height: 144.96,
    rx: 27.84,
    transform: "translate(610.31 635.02) rotate(180)",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "282.75 389.99 256.15 389.99 284.29 245.03 310.9 245.03 282.75 389.99",
    style: {
      fill: "#002557",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.78 389.99 291.65 389.99 319.8 245.03 334.92 245.03 306.78 389.99",
    style: {
      fill: "#002557",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M369.62,291.8H295.7a7.72,7.72,0,0,1,0-15.43h73.92a7.72,7.72,0,1,1,0,15.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M270.37,291.8H236.89a7.72,7.72,0,0,1,0-15.43h33.48a7.72,7.72,0,1,1,0,15.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M369.62,324.32H244.74a7.72,7.72,0,0,1,0-15.43H369.62a7.72,7.72,0,1,1,0,15.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M369.62,356.83H311.77a7.72,7.72,0,0,1,0-15.43h57.85a7.72,7.72,0,1,1,0,15.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M240.72,245s-11.06,59.8-11.06,85.06c0,25.91,9.14,59.9,9.14,59.9H209.59l-1.93-32.81a292,292,0,0,1,9-91.2l5.48-21Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M225.49,416.24c0,1.18-16.4,2.14-36.63,2.14s-36.63-1-36.63-2.14,16.4-2.14,36.63-2.14S225.49,415.06,225.49,416.24Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M212.93,167.73c-3.1.49-6,.74-9,1s-6,.25-9,.23a83.55,83.55,0,0,1-18.16-2,14.69,14.69,0,0,1-5.21-2.62,33.44,33.44,0,0,1-3.66-3.27A63.52,63.52,0,0,1,162.1,154a115.68,115.68,0,0,1-9.19-15.2l3.75-2.25c1.68,2.27,3.41,4.58,5.19,6.79s3.55,4.43,5.43,6.52a67.89,67.89,0,0,0,5.76,5.85,25.07,25.07,0,0,0,3,2.31,7.78,7.78,0,0,0,2.54,1.18,75.47,75.47,0,0,0,8.06.91c2.75.12,5.52.19,8.31.15s5.59-.19,8.38-.39,5.64-.49,8.27-.81Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M221.93,159.61C214.32,155,204,158.35,204,158.35l5.22,18s8.24-2.32,11.47-5.83C224.07,166.89,226.52,162.38,221.93,159.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M157.3,138.42l1.84-6.2-8.71,1.08a17.93,17.93,0,0,0,3.17,6.79Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "158.51 124.99 151.26 126.29 150.43 133.3 159.14 132.22 158.51 124.99",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M257.46,102.75c7.7.16,5.54,6.59,5.54,6.59s8.39-5.3,11.06.89-3.35,8.15-6.87,9.08c2.21,1.27,2.33,5.39-.77,6.74s-8.29-2.36-12.21-2.31l-3.86-4.57C255.59,115.77,249.75,102.59,257.46,102.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M256.26,126.92c3.36.59,5.8.17,5.14-3.54a12.49,12.49,0,0,0-7.78-9.17c-4.24-1.56-5.19,5.44-5.19,5.44Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "158 386.07 149.42 385.08 151.13 365.16 159.71 366.14 158 386.07",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "214.83 409.42 206.21 409.03 204.35 388.93 212.98 389.33 214.83 409.42",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M205.88,406.42h9.7a.69.69,0,0,1,.69.59l1.1,7.68a1.38,1.38,0,0,1-1.38,1.53c-3.38-.06-5-.25-9.28-.25-2.62,0-6.46.27-10.08.27s-3.81-3.58-2.31-3.91c6.77-1.45,7.84-3.46,10.12-5.37A2.22,2.22,0,0,1,205.88,406.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M149.13,381.94l9.63-1.14a.69.69,0,0,1,.76.51l2,7.49a1.39,1.39,0,0,1-1.2,1.68c-3.36.34-5,.34-9.24.84-2.6.31-8,1.22-11.56,1.64s-4.21-3.11-2.75-3.61c6.55-2.24,8.95-4.54,11-6.71A2.27,2.27,0,0,1,149.13,381.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "151.14 365.16 150.25 375.43 158.83 376.42 159.72 366.15 151.14 365.16",
    style: {
      fill: "#ea7063"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "212.98 389.33 204.35 388.94 205.31 399.3 213.94 399.69 212.98 389.33",
    style: {
      fill: "#ea7063"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M213.57,157.32s-4.35.27-10.24,51.25l33.73,9.56c3.33-13.89,5.71-22.36,20.26-48.67a103.66,103.66,0,0,0-13.79-6,112.05,112.05,0,0,0-15.32-4.34C221.46,157.91,213.57,157.32,213.57,157.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M246.9,145.84c-2.36,4.65-5.89,13.41-3.37,17.67,0,0-2.77,4.62-11.92,2-10.07-2.85-3.4-6.36-3.4-6.36,5.87.25,6.88-3.87,7-8Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M218.78,157.82c2.76.3,6.23.75,9.43,1.35a111.26,111.26,0,0,1,15.32,4.34c2.87,1,5.65,2.1,7.94,3.13C251,168.31,247.69,177,228,172,209.68,167.28,216.69,159.52,218.78,157.82Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M242.14,148l-6.91,3.17a16.59,16.59,0,0,1-.3,2.86c2.18.29,5.88-.69,6.73-2.83A9.29,9.29,0,0,0,242.14,148Z",
    style: {
      fill: "#ea7063"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M251.29,134.89c-2.07,8.31-2.76,11.88-7.8,15.41-7.58,5.32-17.35,1-17.81-7.79-.42-7.89,3-20.16,11.87-22A11.69,11.69,0,0,1,251.29,134.89Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M248.59,142.91c-2.51-1.3-4.52-5-.9-8.44,0,0-5-2.85-2.49-6.78s12.54-7.2,14.11-1.92-3.31,7.45-3.31,7.45,4,6.12-3.19,8.14c0,0-.62,8.83-5.78,4.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M251.2,142.72a6.31,6.31,0,0,1-3,3.71c-1.94,1-3.38-.59-3.24-2.66.13-1.87,1.3-4.66,3.43-4.83A2.81,2.81,0,0,1,251.2,142.72Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M203.33,208.57s-39.18,46.21-45.81,71.69c-6.9,26.5-10,92-10,92L161,374s9-59.93,20.33-84.35c12.06-26,46.75-74.06,46.75-74.06Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "162.8 374.22 145.65 371.98 145.35 367.28 164.22 371.11 162.8 374.22",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "162.8 374.22 145.65 371.98 145.35 367.28 164.22 371.11 162.8 374.22",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M202.66,229.58a254.52,254.52,0,0,0-7.22,34.6c3.58-5.8,7.35-11.67,11-17.23,1.33-2.94,2.69-5.85,4-8.69,0,0,0-.06,0-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M212.24,211.09S200.9,269.46,196.8,303c-3.32,27.1,7.13,92.83,7.13,92.83l11.24.69s-2.37-58.7,2.85-84.95c13.22-66.41,25.58-75.32,19-93.44Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "216.56 396.6 202.01 395.71 201.33 391.57 217.09 393.21 216.56 396.6",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "216.56 396.6 202.01 395.71 201.33 391.57 217.09 393.21 216.56 396.6",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M238.13,216.29l.66,3.45c.05.27-.29.43-.68.32l-35.37-10c-.31-.08-.52-.3-.48-.5l.55-3.1c0-.22.35-.32.68-.23l34.16,9.68A.68.68,0,0,1,238.13,216.29Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M238.13,216.29l.66,3.45c.05.27-.29.43-.68.32l-35.37-10c-.31-.08-.52-.3-.48-.5l.55-3.1c0-.22.35-.32.68-.23l34.16,9.68A.68.68,0,0,1,238.13,216.29Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M232.46,218.81l.91.26c.18.05.35,0,.37-.12l.68-4c0-.12-.11-.26-.29-.31l-.92-.26c-.18-.05-.34,0-.36.12l-.69,4C232.14,218.62,232.28,218.76,232.46,218.81Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M205.21,211.09l.92.26c.18.05.35,0,.37-.12l.68-4c0-.11-.11-.25-.3-.3l-.91-.26c-.18-.06-.35,0-.37.12l-.68,4C204.9,210.9,205,211,205.21,211.09Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M218.84,215l.91.26c.18,0,.35,0,.37-.12l.68-4c0-.12-.11-.26-.29-.31l-.92-.26c-.18-.06-.35,0-.37.12l-.68,4C218.52,214.76,218.65,214.9,218.84,215Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M238.1,134.9c-.13.68-.59,1.17-1,1.09s-.71-.71-.58-1.39.59-1.18,1-1.09S238.22,134.21,238.1,134.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M230.36,133.47c-.13.69-.59,1.18-1,1.09s-.71-.7-.58-1.38.59-1.18,1-1.1S230.48,132.79,230.36,133.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M230,132.16l-1.55-.78S229,132.82,230,132.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M232.19,135a18.79,18.79,0,0,1-3.25,3.92,3,3,0,0,0,2.36.9Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M234.42,143.11a6.61,6.61,0,0,1-1.21-.12.2.2,0,0,1-.16-.23.21.21,0,0,1,.24-.17,5.52,5.52,0,0,0,4.81-1.31.21.21,0,0,1,.3.29A5.74,5.74,0,0,1,234.42,143.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M241,132.83a.4.4,0,0,1-.36-.22,3.27,3.27,0,0,0-2.33-1.82.41.41,0,1,1,.09-.81,4.06,4.06,0,0,1,3,2.26.41.41,0,0,1-.18.55A.43.43,0,0,1,241,132.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M227.57,129.27a.39.39,0,0,1-.28-.12.4.4,0,0,1,0-.58,4.09,4.09,0,0,1,3.51-1.27.42.42,0,0,1,.32.48.4.4,0,0,1-.48.32,3.25,3.25,0,0,0-2.76,1A.41.41,0,0,1,227.57,129.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M258.37,178.93c.68,3.06,1.11,5.94,1.51,8.92s.61,6,.78,8.94a84.11,84.11,0,0,1-.93,18.25,14.58,14.58,0,0,1-2.3,5.36,33.45,33.45,0,0,1-3,3.85,65.27,65.27,0,0,1-6.69,6.26A115.07,115.07,0,0,1,233.1,240.6l-2.47-3.6c2.16-1.82,4.36-3.69,6.46-5.59s4.21-3.82,6.17-5.82a67.55,67.55,0,0,0,5.5-6.11,25.34,25.34,0,0,0,2.12-3.12,7.71,7.71,0,0,0,1-2.61,73.53,73.53,0,0,0,.42-8.1c0-2.76-.15-5.53-.36-8.31s-.53-5.56-.9-8.34-.83-5.6-1.31-8.2Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M257.32,169.46c3.08,2,3.85,14.77,3.85,14.77l-15.77,5.66s-2-11.07.63-15C248.8,170.72,253.79,167.19,257.32,169.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.92,407.93a2.44,2.44,0,0,1-1.64-.45,1.16,1.16,0,0,1-.34-1.08.7.7,0,0,1,.41-.58c1-.46,3.62,1.24,3.92,1.43a.22.22,0,0,1,.09.21.22.22,0,0,1-.16.16A10.13,10.13,0,0,1,202.92,407.93Zm-1.14-1.78a.65.65,0,0,0-.26,0,.28.28,0,0,0-.17.26.77.77,0,0,0,.2.73c.44.4,1.57.45,3.08.15A7.64,7.64,0,0,0,201.78,406.15Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,407.63a.17.17,0,0,1-.1,0c-.83-.47-2.4-2.33-2.2-3.3a.69.69,0,0,1,.69-.57,1.06,1.06,0,0,1,.86.27c.94.83,1,3.32,1,3.42a.21.21,0,0,1-.1.18A.19.19,0,0,1,205.16,407.63Zm-1.47-3.5h-.1c-.26,0-.31.14-.33.24-.12.59.86,2,1.68,2.65a4.68,4.68,0,0,0-.8-2.72A.66.66,0,0,0,203.69,404.13Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,383.87a2.42,2.42,0,0,1-1.38-.33,1.13,1.13,0,0,1-.48-.94.67.67,0,0,1,.28-.59c1-.7,4.6.64,5,.8a.2.2,0,0,1,.13.2.2.2,0,0,1-.14.19A12.36,12.36,0,0,1,145.33,383.87Zm-.72-1.65a1.16,1.16,0,0,0-.63.13.24.24,0,0,0-.1.23.74.74,0,0,0,.31.63c.57.4,2,.32,3.85-.22A12.64,12.64,0,0,0,144.61,382.22Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.69,383.21h-.06c-1.08-.34-3.32-1.95-3.27-2.94,0-.24.13-.54.69-.67a1.53,1.53,0,0,1,1.17.22c1.18.77,1.65,3.05,1.67,3.15a.21.21,0,0,1-.06.19A.2.2,0,0,1,148.69,383.21Zm-2.3-3.25a1.07,1.07,0,0,0-.25,0c-.37.08-.37.23-.38.28,0,.6,1.52,1.89,2.64,2.4a4.76,4.76,0,0,0-1.41-2.52A1.12,1.12,0,0,0,146.39,380Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,130.48a66.67,66.67,0,0,0-78,87.06L88.09,238.22l29.39-2.28a66.69,66.69,0,1,0,68-105.46Z",
    style: {
      fill: "#002557",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,130.48a66.67,66.67,0,0,0-78,87.06L88.09,238.22l29.39-2.28a66.69,66.69,0,1,0,68-105.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.54,258.91h0A63.63,63.63,0,0,1,120.06,234L119,232.56,96.58,234.3a.18.18,0,0,1-.14-.08.16.16,0,0,1,0-.16l14.81-15.73-.65-1.87A63.43,63.43,0,0,1,170.42,132a63.47,63.47,0,0,1,61.87,77.76A63.13,63.13,0,0,1,170.54,258.91Zm-51.48-26.64a.14.14,0,0,1,.11.06l1.12,1.47a63.29,63.29,0,0,0,50.25,24.83h0a63.17,63.17,0,0,0,14.18-124.71,63.51,63.51,0,0,0-14.3-1.64,63.15,63.15,0,0,0-59.52,84.09l.68,1.95a.12.12,0,0,1,0,.14L96.93,234l22.12-1.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.62,184.1a1.78,1.78,0,0,0-.54-2.11,30.73,30.73,0,0,0-11.56-5.19,27.68,27.68,0,0,0-33.18,20.71c-2.3,9.93,3.15,16.67,9.72,18.19a17.82,17.82,0,0,0,15.72-3.55,9.35,9.35,0,0,0,7.58,8.94c10.27,2.38,22.82-4.51,26.93-22.27,4.43-19.12-5.93-35.59-25.18-40-23.12-5.35-44.8,8.92-50.42,33.2-4.68,20.24,6.21,38.23,25.89,42.79,7.81,1.81,14.22,1.84,20.78.11a1.77,1.77,0,0,0,1.3-1.94l-.64-5a1.79,1.79,0,0,0-.79-1.25,1.72,1.72,0,0,0-1.46-.22,32.54,32.54,0,0,1-16,0c-15.32-3.55-23.11-16.78-19.37-32.94,4.5-19.47,20.47-30.66,38-26.61,14.82,3.43,21.83,15,18.3,30.33-1.55,6.69-4.74,11.93-8.76,14.39a6.79,6.79,0,0,1-5.07,1.11,1.65,1.65,0,0,1-1.23-.93c-.43-.88-.74-3.27,2-9.3Zm-15.48,1.49a18.06,18.06,0,0,1,3.26,1.08l-4.36,10c-2.46,5.78-9.25,11.6-14.3,10.43-4.61-1.06-4.37-5.21-3.82-7.58C161.1,190.06,169.91,183.69,178.14,185.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M232.5,236.24l-7.58-4.3,1.61,8.63s5.26,1.74,7.86-.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--path--inject-85",
    points: "217.74 233.01 219.48 240.16 226.53 240.57 224.92 231.94 217.74 233.01",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M237.71,133.58l-1.56-.78S236.76,134.24,237.71,133.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M248.43,129.63c-4.28-.27-7.42-2.15-7.84-4.62,0,0-9.82,4.08-13.79-2,0,0-4.48.74-5.59-2.38s3.55-4,5.75-2.6c0,0-6.82-6,.18-7.67s8.5,4,8.5,4,2.76-8.28,9-4.6S247,117,247,117s14.82,1.15,9.3,7S248.43,129.63,248.43,129.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--path--inject-85",
    d: "M243.07,158.37c.84.08.47,3,.09,3.2-.87.47-11.35-1.68-11-3.3a7,7,0,0,1,1.48-2.08C234.1,155.85,235.7,157.76,243.07,158.37Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--quotation-marks--inject-85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.8,181.27a16.73,16.73,0,0,0-2.36,33.3,17.12,17.12,0,0,1-4.16,11.53s23.26-5.79,23.26-28.09A16.74,16.74,0,0,0,297.8,181.27Z",
    style: {
      fill: "#002557"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,181.27a16.73,16.73,0,0,0-2.36,33.3A17.12,17.12,0,0,1,329,226.1s23.26-5.79,23.26-28.09A16.73,16.73,0,0,0,335.47,181.27Z",
    style: {
      fill: "#002557"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionRafiki);
export default __webpack_public_path__ + "static/media/Mention-rafiki.4e155af0427a7d9f6c5b5f55930b6b1e.svg";
export { ForwardRef as ReactComponent };